import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Tag from '../../Common/Tag/Tag';
import { SetComponentLanguage } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';

import './Filters.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class Filters extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        };
    }

    toggleFilters = () => {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    toggle = () => {
        this.props.resetFilters();
        this.toggleFilters(false);
    }

    applyFilters = () => {
        this.toggleFilters(false);
    }

    applyFiltersAndSearch = () => {
        this.toggleFilters(false);
        this.props.applyFilters();
    }

    render() {
        return (
            
            <div className="showtix-section container">
                <button
                    className="showtix-button showtix-background__primary-1"
                    onClick={this.toggleFilters}
                >
                    {strings.filterBtn}
                </button>

                <Modal isOpen={this.state.isOpen} toggle={this.toggle}>
                    <ModalHeader toggle={this.toggle}>{strings.title}</ModalHeader>
                    <ModalBody className="text-left">
                        <div className="row">
                            <div className="col-12">
                                <h5>{strings.checkinStatus}</h5>
                            </div>
                        </div>    
                        <div className="row">
                            <div className="col-12 col-sm-6">
                                <div className="showtix-form__checkbox">
                                    <input
                                        type="checkbox"
                                        className="showtix-input"
                                        id="checkedin"
                                        name="checkedin"
                                        value="true"
                                        object="checkinStatus"
                                        onChange={this.props.handleChangeFilter}
                                        checked={this.props.items.filters.checkinStatus.indexOf('true') !== -1}
                                    />
                                    <label className="showtix-label" htmlFor="checkedin">{strings.checkedIn}</label>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6">
                                <div className="showtix-form__checkbox">
                                    <input
                                        type="checkbox"
                                        className="showtix-input"
                                        id="checkedout"
                                        name="checkedout"
                                        value="false"
                                        object="checkinStatus"
                                        onChange={this.props.handleChangeFilter}
                                        checked={this.props.items.filters.checkinStatus.indexOf('false') !== -1}
                                    />
                                    <label className="showtix-label" htmlFor="checkedout">{strings.notCheckedIn}</label>
                                </div>
                            </div>
                        </div> 
                        <hr />
                        <div className="row">
                            <div className="col-12">
                                <h5>{strings.transactionStatus}</h5>
                            </div>
                        </div> 
                        <div className="row">
                            <div className="col-12 col-sm-6">
                                <div className="showtix-form__checkbox">
                                    <input
                                        type="checkbox"
                                        className="showtix-input"
                                        id="released"
                                        name="released"
                                        value="released"
                                        object="transactionStatus"
                                        onChange={this.props.handleChangeFilter}
                                        checked={this.props.items.filters.transactionStatus.indexOf('released') !== -1}
                                    />
                                    <label className="showtix-label" htmlFor="released">{strings.released}</label>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6">
                                <div className="showtix-form__checkbox">
                                    <input
                                        type="checkbox"
                                        className="showtix-input"
                                        id="reserved"
                                        name="reserved"
                                        value="reserved"
                                        object="transactionStatus"
                                        onChange={this.props.handleChangeFilter}
                                        checked={this.props.items.filters.transactionStatus.indexOf('reserved') !== -1}
                                    />
                                    <label className="showtix-label" htmlFor="reserved">{strings.reserved}</label>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6">
                                <div className="showtix-form__checkbox">
                                    <input
                                        type="checkbox"
                                        className="showtix-input"
                                        id="vipatron"
                                        name="vipatron"
                                        value="vipatron"
                                        object="transactionStatus"
                                        onChange={this.props.handleChangeFilter}
                                        checked={this.props.items.filters.transactionStatus.indexOf('vipatron') !== -1}
                                    />
                                    <label className="showtix-label" htmlFor="vipatron">{strings.vipatron}</label>
                                </div>
                            </div>
                        </div> 
                        <hr />
                        {this.props.items.coupons.length > 0 &&
                            <div>
                                <div className="row">
                                    <div className="col-12">
                                        <h5>{strings.coupons}</h5>
                                    </div>
                                </div> 
                                <div className="row">
                                    {this.props.items.coupons.map((coupon, i) => 
                                        <div className="col-12 col-sm-6" key={i}>
                                            <div className="showtix-form__checkbox">
                                                <input
                                                    type="checkbox"
                                                    className="showtix-input"
                                                    id={"coupon-" + i}
                                                    object="coupons"
                                                    name={"coupon" + i}
                                                    value={coupon.id}
                                                    onChange={this.props.handleChangeFilter} 
                                                    checked={this.props.items.filters.coupons.indexOf(coupon.id) !== -1}
                                                />
                                                <label className="showtix-label" htmlFor={"coupon-" + i}>{coupon.name}</label>
                                            </div>    
                                        </div>
                                    )}
                                </div> 
                                <hr />
                            </div>    
                        }
                        {this.props.items.tags.length > 0 &&
                            <div>
                                <div className="row">
                                    <div className="col-12">
                                        <h5>{strings.tags}</h5>
                                    </div>
                                </div> 
                                <div className="row">
                                    <div className="col-12">
                                        <div className="d-flex flex-wrap">
                                            {this.props.items.tags.map((tag, i) => {
                                                return <Tag
                                                    key={i}
                                                    object="tags"
                                                    id={"tag" + i}
                                                    value={tag.id}
                                                    name={tag.tag_name}
                                                    handleChangeFilter={this.props.handleChangeFilter}
                                                    isActive={this.props.items.filters.tags.indexOf(tag.id) !== -1}
                                                />
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }           
                    </ModalBody>
                    <ModalFooter className="text-center">
                        <button 
                            type="submit" 
                            className="showtix-button showtix-background__primary-3"
                            onClick={this.applyFiltersAndSearch}
                            >{strings.apply}</button>    
                    </ModalFooter>
                </Modal>
            </div>    
        )
    }
}

Filters.propTypes = {
    items: PropTypes.shape({
        filters: PropTypes.shape({
            checkinStatus: PropTypes.array,
            transactionStatus: PropTypes.array,
            coupons: PropTypes.array,
            tags: PropTypes.array,
        }),
        coupons: PropTypes.array,
        tags: PropTypes.array
    }),
    resetFilters: PropTypes.func,
    applyFilters: PropTypes.func,
    handleChangeFilter: PropTypes.func
}

export default Filters;


// WEBPACK FOOTER //
// ./src/components/Search/Filters/Filters.js